module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Safe-chat-d05c24ba17afbceac566af817d9d0251.svg";